
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"90","height":"90","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.172 87.293c12.426 0 22.5-10.074 22.5-22.5 0-12.427-10.074-22.5-22.5-22.5s-22.5 10.073-22.5 22.5c0 12.426 10.074 22.5 22.5 22.5zm8.438-30.938L56.733 73.23m.001-16.875L73.61 73.23M5.71 43.282l4.756 7.126a6.75 6.75 0 005.625 3h16.762M2.328 43.282h37.275m1.61-30.431a5.07 5.07 0 100-10.14 5.07 5.07 0 000 10.14zM10.785 43.282a30.435 30.435 0 0159.681-8.407","stroke":"#16213E","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    